import { useState } from "react";

import { SearchIcon } from "@/components/atoms/icons";
import { Button } from "@/components/atoms/prime/Button";

import Searchbar from "./Searchbar.component"; // Import the Searchbar component

interface SearchComponentProps {
  onSearch: (query: string) => void;
  showSearchBar?: boolean;
  value?: string;
  placeholder?: string;
}

const SearchComponent: React.FC<SearchComponentProps> = ({
  onSearch,
  showSearchBar,
  value,
  placeholder = "Buscar",
}) => {
  const [mostrarSearchbar, setMostrarSearchbar] = useState(!!value);

  const toggleSearchbar = () => {
    setMostrarSearchbar(!mostrarSearchbar);
  };

  return (
    <div className="my-1 mr-1">
      {mostrarSearchbar || showSearchBar ? (
        <Searchbar
          placeholder={placeholder}
          value={value}
          onCancel={() => setMostrarSearchbar(false)}
          onSearch={onSearch}
        />
      ) : (
        <Button
          link
          icon={<SearchIcon />}
          tooltip="Buscador"
          tooltipOptions={{ position: "top" }}
          onClick={toggleSearchbar}
        />
      )}
    </div>
  );
};

export default SearchComponent;
